export default function GradientBorderWrapper({
    children,
    borderWidth = "0.8px",
    className = "",
    style
}) {
    return (
        <div
            className={`flex justify-center items-center ${className}`}
            style={{
                ...style,
                padding: borderWidth,
            }}
        >
            {children}
        </div>
    );
}